export enum ResourceUserRestrictionEnum {
    RestrictBooking = 0,
    ForViewOrderForm = 1
}